<template>
  <loader v-if="!dataLoaded"/>
  <v-container v-else>
    <v-row>
      <v-col :cols="12">
        <h1>{{ $t('texts.profile') }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <v-card>
          <v-card-title class="pb-0">
            <span class="headline">{{ $t('texts.userData') }}</span>
          </v-card-title>
          <v-card-text>
            <form>
              <user-data
                :form="form"
              />
            </form>
          </v-card-text>
          <v-card-title class="pb-0">
            <span class="headline">{{ $t('texts.profilePicture') }}</span>
          </v-card-title>
          <v-card-text>
            <user-image
              :userImage="form.image"
            />
          </v-card-text>
          <v-card-text class="pt-0">
            {{ $t('texts.profilePicture-size-info') }}<br>
            {{ $t('texts.company.profile.images-type-info') }}
          </v-card-text>
          <v-card-title class="pb-0">
            <span class="headline">
              {{ $t('texts.company.profile.settings' )}}
            </span>
          </v-card-title>
          <v-card-text>
            <form>
              <user-settings
                :form="form"
              />
            </form>
          </v-card-text>
          <v-divider/>
          <v-card-actions class="py-3 px-5">
            <v-spacer/>
            <v-btn
              color="primary"
              class="white--text"
              @click="updateProfile()"
              :disabled="updateUserProfilePending"
              :loading="updateUserProfilePending"
            >
              {{ $t('texts.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import UserData from './UserData.vue';
import UserImage from './UserImage.vue';
import UserSettings from './UserSettings.vue';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  name: 'EmployeeProfileGeneral',
  components: {
    UserData,
    UserImage,
    UserSettings,
  },
  data() {
    return {
      dataLoaded: false,
      form: {
        sex: 1,
        first_name: '',
        last_name: '',
        date_of_birth: null,
        email: '',
        nationality: '',
        residence_permit: null,
        language: '',
        street: '',
        street_number: '',
        zip: '',
        place: '',
        country: '',
        phone: '',
        newsletter: false,
        image: '',
      },
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  created() {
    this.fetchUserProfile().then(() => {
      Object.assign(this.form, this.authUser);
      this.$validator.reset();
      this.dataLoaded = true;
    });
  },
  computed: {
    ...mapUserState([
      'authUser',
      'updateUserProfilePending',
    ]),
  },
  methods: {
    ...mapUserActions([
      'fetchUserProfile',
      'updateUserProfile',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    updateProfile() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$gtm.trackEvent({
            event: null, // Event type [default = 'interaction'] (Optional)
            category: 'Save Profile',
            action: 'click',
            label: 'Employee',
            value: 1,
            noninteraction: false, // Optional
          });
          if (this.form.nationality === 'CH') {
            this.residence_permit = null;
          }
          this.updateUserProfile(this.form);
        } else {
          this.showMessageValidateError();
        }
      });
    },
  },
};
</script>
